export default __webpack_public_path__ + "static/media/1.34618e32.png";